export const TINY_SLIDER_KEY = "ldw/tiny-slider";

export const IS_BROWSER = typeof window !== "undefined";
